import { FC } from 'react'
import styled from 'styled-components'

import { ALERT_INTENT, Alert } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { ThreadEmojiWrapper } from '../../shared-form-styles'
import { FormBody } from '../../shared-form-styles'
import { SubmissionButtons } from '../../SubmissionButtons'
import * as Styles from '../EmbroideryLogoSetup/styles'
import { LogoFormContainer } from '../LogoFormContainer'

import { LogoPlacement } from './LogoPlacement'
import { LogoSelector } from './LogoSelector'

export const AddEmbroideryLogo: FC = () => {
  const { addLogoForm, resetLogoForms, logoTotalPrice, hasActiveLogoSetup, transientLogo } =
    LogoFormContainer.useContainer()

  const {
    embroidery: {
      modal: {
        forms: {
          dtcLogoEmbroideryForm: { digitizationDisclaimer, digitizationOneAtATime },
        },
      },
    },
  } = useTranslation()

  return (
    <>
      <FormBody onSubmit={addLogoForm.handleSubmit}>
        <LogoSelector />

        <LogoPlacement />
        <Styles.StyledHr />
        {hasActiveLogoSetup && (
          <WarningLabel>
            <ThreadEmojiWrapper aria-label='thread' role='img'>
              🧵
            </ThreadEmojiWrapper>
            <div>{digitizationDisclaimer}</div>
          </WarningLabel>
        )}
        <SubmissionButtons
          displayPrice={logoTotalPrice}
          disableReset={!hasActiveLogoSetup}
          onReset={() => {
            resetLogoForms()
          }}
        />
        {(hasActiveLogoSetup || transientLogo) && (
          <WarnAlert intent={ALERT_INTENT.Warn}>
            <Alert.Message>{digitizationOneAtATime}</Alert.Message>
          </WarnAlert>
        )}
      </FormBody>
    </>
  )
}

const WarningLabel = styled(Styles.WarningLabel)`
  margin: ${({ theme }) => theme.spacing(6, 0, 6, 0)};
  gap: ${({ theme }) => theme.spacing(4)};
`

const WarnAlert = styled(Alert)`
  margin: ${({ theme }) => theme.spacing(6, 0, 0, 0)};
`
